import { useRef } from 'react';

export const useFocus = () => {
  const htmlElRef = useRef(null);
  const setFocus = () => {
    setTimeout(() => {
      htmlElRef.current && htmlElRef.current.focus();
    }, 1);
  };

  return [htmlElRef, setFocus];
};
